















































import { Vue, Component } from "vue-property-decorator";
import CalendarTable from "@/components/settings/CalendarTable.vue";
import CalendarService from "@/services/calendarService";
import { getModule } from "vuex-module-decorators";
import SnackbarModule from "@/store/snackbarModule";
import UserModule from "@/store/userModule";
import ValidationService from "@/services/validationService";
import { DataTableHeader } from "vuetify";
import CalendarModel from "@/models/calendar/calendarModel";

const snackbarModule = getModule(SnackbarModule);
const userModule = getModule(UserModule);

@Component({ components: { CalendarTable } })
export default class Calendars extends Vue {
  private items: Array<CalendarModel> = [];
  private dialogEdit: CalendarModel = new CalendarModel();
  private validationService: ValidationService = new ValidationService();
  private dialog = false;
  private dialogLoading = false;
  private loading = false;
  private dialogCreateMode = false;
  private headers: Array<DataTableHeader<CalendarModel>> = [
    {
      text: "Title",
      value: "title"
    },
    {
      text: "",
      value: "action",
      sortable: false
    },
    {
      text: "",
      value: "delete",
      sortable: false
    }
  ];

  private async created(): Promise<void> {
    await this.getCalendars();
  }

  get userRole(): string {
    return userModule.userRole;
  }

  private async getCalendars() {
    try {
      this.loading = true;
      this.items = await CalendarService.getAllCalendarsByUserAsync(
        userModule.userId
      );
    } catch {
      snackbarModule.snackError("Failed to fetch calendars");
    } finally {
      this.loading = false;
    }
  }

  private async onDeleteItem(item: CalendarModel) {
    if (
      confirm(
        "Deleting this Calendar will also delete any events attached to this calendar, Are you sure you want to delete this Calendar?"
      )
    ) {
      try {
        await CalendarService.deleteCalendar(item.calendarId);
        snackbarModule.snackSuccess("Calendar deleted");
      } catch {
        snackbarModule.snackError("Calendar delete failed");
      }
      await this.getCalendars();
    }
  }

  private async onBeginEditItem(item: CalendarModel) {
    this.dialogCreateMode = false;
    this.dialog = true;
    this.dialogEdit = new CalendarModel(item);
  }

  private async onBeginCreateItem() {
    this.dialogCreateMode = true;
    this.dialog = true;
    this.dialogEdit = new CalendarModel();
  }

  private async onCancel() {
    (this.$refs.form as Vue & { reset: () => void }).reset();
    this.dialog = false;
    this.dialogEdit = new CalendarModel();
  }

  private async onNavigateItem(item: CalendarModel) {
    this.$router.push({
      name: "Calendar View",
      params: { id: item.calendarId }
    });
  }

  private async onEditItem() {
    if (!this.validateForm()) {
      return;
    }

    try {
      this.dialogLoading = true;
      this.dialogEdit.userId = userModule.userId;
      await CalendarService.updateCalendar(
        this.dialogEdit.calendarId,
        this.dialogEdit
      );
      snackbarModule.snackSuccess("Calendar updated");
      this.dialog = false;
    } catch {
      snackbarModule.snackError("Calendar update failed");
    } finally {
      this.dialogLoading = false;
    }
    await this.getCalendars();
  }

  private async onCreateItem() {
    if (!this.validateForm()) {
      return;
    }

    try {
      this.dialogLoading = true;
      this.dialogEdit.userId = userModule.userId;
      await CalendarService.createCalendar(this.dialogEdit);
      snackbarModule.snackSuccess("Calendar Created");
      this.dialog = false;
    } catch {
      snackbarModule.snackError("Failed to create calendar");
    } finally {
      this.dialogLoading = false;
    }
    await this.getCalendars();
  }

  private validateForm(): boolean {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }
}
